import { EDocsRoles } from './EDocsRoles';
import { Role } from '../../gs-core/common/models';
import {
  BUSINESS_SCHOOL, GRADUATE_SCHOOL, LAW_SCHOOL, MED_SCHOOL, UC_DAVIS,
  VET_SCHOOL, NURSING_SCHOOL
} from './CampusDivisions';

export type SubjectType =
  'STUDENT' |
  'POSTDOC' |
  'PROGRAM';

export const SubjectTypes = {
  STUDENT: 'STUDENT' as SubjectType,
  POSTDOC: 'POSTDOC' as SubjectType,
  PROGRAM: 'PROGRAM' as SubjectType,

  parse(code: string): SubjectType {
    if (!code || typeof code !== 'string' || code.toUpperCase() !== code || !(code in SubjectTypes)) {
      throw new Error(`Invalid subject type ${code}`);
    }

    return SubjectTypes[code];
  },

  fromRole(roleOrCode: Role | string): SubjectType {
    const roleCode = typeof roleOrCode === 'string' ? roleOrCode : roleOrCode.code;

    const roleToType = {
      [EDocsRoles.STUDENT.code]: SubjectTypes.STUDENT,
      [EDocsRoles.POSTDOC.code]: SubjectTypes.POSTDOC,
      [EDocsRoles.SUBUNIT.code]: SubjectTypes.PROGRAM
    };

    const type = roleToType[roleCode];

    if (!type) {
      throw new Error(`Invalid role ${roleCode}`);
    }

    return type;
  },

  toRole(type: SubjectType): Role {
    const typeToRole = {
      [SubjectTypes.STUDENT]: EDocsRoles.STUDENT,
      [SubjectTypes.POSTDOC]: EDocsRoles.POSTDOC,
      [SubjectTypes.PROGRAM]: EDocsRoles.SUBUNIT
    };

    const role = typeToRole[type];

    if (!role) {
      throw new Error(`Invalid SubjectType ${type}`);
    }

    return role;
  },

  topOrganizations(type: SubjectType) {
    return type === SubjectTypes.POSTDOC ?
      [UC_DAVIS] :
      [GRADUATE_SCHOOL, BUSINESS_SCHOOL, LAW_SCHOOL, VET_SCHOOL, MED_SCHOOL, NURSING_SCHOOL];
  },

  all(): SubjectType[] {
    return Object.keys(SubjectTypes)
      .filter(key => typeof SubjectTypes[key] === 'string')
      .map(key => SubjectTypes[key]);
  }
};



// WEBPACK FOOTER //
// ./src/common/models/SubjectType.ts